import { ExperimentA } from 'ui/icons';
import { colors } from 'ui/theme';
import { Trophy } from 'modules/experiments/components/ui';
import { SummaryBadgeColors } from 'modules/experiments/constants';
import { StyledExperimentStatusBadge } from './Styled';

interface ExperimentSummaryStatusBadgeProps {
  color: SummaryBadgeColors;
  includesSubText: boolean;
}

export const ExperimentSummaryStatusBadge = ({
  color,
  includesSubText,
}: ExperimentSummaryStatusBadgeProps) => {
  let badgeColor = colors.grey5;
  let iconColor = colors.secondaryText;

  if (color === SummaryBadgeColors.Blue) {
    badgeColor = colors.cyan10;
    iconColor = colors.cyan100;
  } else if (color === SummaryBadgeColors.Green) {
    badgeColor = colors.green10;
    iconColor = colors.green100;
  }

  const iconProps = {
    height: 20,
    width: 20,
    color: iconColor,
  };

  return (
    <StyledExperimentStatusBadge
      data-test={`experiment-summary-badge-${color}`}
      color={badgeColor}
      includesSubText={includesSubText}
    >
      {color === SummaryBadgeColors.Green ? (
        <Trophy {...iconProps} />
      ) : (
        <ExperimentA {...iconProps} />
      )}
    </StyledExperimentStatusBadge>
  );
};
